import './styles.css';
import { AstraLoomApp } from './app/AstraLoomApp';

const mount = document.querySelector<HTMLElement>('#app');

if (!mount) {
  throw new Error('Astra Loom mount element was not found.');
}

const app = new AstraLoomApp(mount);
void app.start();

if (import.meta.hot) {
  import.meta.hot.dispose(() => app.dispose());
}
